import { Link as RouterLink } from 'react-router-dom';
// material
import { alpha, styled } from '@mui/material/styles';
import {
  Link,
  Stack,
  Avatar,
  Typography,
  IconButton,
  Paper,
  Tooltip
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { AuthUser } from '../../@types/authentication';

interface CurrentUserCardProps {
    user: AuthUser;
    onLogout: VoidFunction;
  }

  const AccountStyle = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    borderRadius: theme.shape.borderRadiusSm,
    backgroundColor: theme.palette.grey[500_12]
  }));
  
export const CurrentUserCard = ({ user, onLogout }: CurrentUserCardProps) => {
    if (!user) return null;

    return (
        <Link underline="none" component={RouterLink} to="#">
          <AccountStyle 
            elevation={0} 
            sx={{ 
              p: 2,
              display: 'flex', 
              alignItems: 'center',
              gap: 2
            }}
          >
            <Avatar 
              alt={user.email} 
              src="/static/mock-images/avatars/avatar_default.jpg"
              sx={{ width: 48, height: 48 }}
            />
            
            <Stack spacing={0.5} flex={1} minWidth={0}>
              <Tooltip title={user.email}>
                <Typography
                variant="subtitle2"
                noWrap
                >
                {user.email}
                </Typography>
              </Tooltip>
              <Typography variant="body2" color="text.secondary" noWrap>
                {user.role}
              </Typography>
            </Stack>

            <IconButton onClick={onLogout} size="small" sx={{ ml: 'auto' }}>
              <LogoutIcon fontSize="small" />
            </IconButton>
          </AccountStyle>
        </Link>
      );
};